import React, { Component } from 'react'
import { connect } from 'react-redux'
import copy from 'fast-copy'
import moment from 'moment'
import Icon from 'components/icon/icon'
import Todo from './todo';

import { DragDropContext, Droppable } from 'react-beautiful-dnd'

import Checkbox from 'components/input/checkbox'

import { getAccountTodos } from 'state/selectors/todoSelector'

import ValidateResponse from 'components/validations/validate-response'
import withValidateResponse from 'components/validations/withValidateResponse'

import { 
	getPrimaryColumnValue, 
	isMobile,
	doSort
} from 'utils'

import InputStandard from 'components/input/standard'

import AlertBanner from 'components/alerts/alert-banner'

import {
	createTodoDay,
	changeTodoDay,
	createTodo,
	updateTodo,
	updateTask,
	updateTodoOrder,
	updateChecklistItemOrder,
	refreshUserData,
	createChecklistItem
} from 'state/actions'

class Todos extends Component {
	state = {
		inputValue: '',
		isDragging: false,
		showCompleted: false,
		areInputsVisible: false,
		areInputsTransitionedIn: false
	}

	todoDays = []
	hasCheckedIfTodayExists = false
	currentTododay = null

	componentDidUpdate = prevProps => {
		this.checkIfTodayExists()

		if (this.props.isActive && !prevProps.isActive) {
			this.focusInput(1)
		}
	}

	componentDidMount = _ => {
		this.checkIfTodayExists()

		this.focusInput(300)

		setTimeout(_ => {
			this.setState({
				areInputsVisible: true
			})

			setTimeout(_ => {
				this.setState({
					areInputsTransitionedIn: true
				})
			},1)
		}, 1)
	}

	focusInput = timeout => {
		setTimeout(_ => {
			if (!isMobile() && this.refs.todoInputElement) {
				this.refs.todoInputElement.inputRef.focus()
			}
		}, timeout)
	}

	checkIfTodayExists = _ => {
		const {
			isChecklist,
			allTodoDays,
			createTodoDay
		} = this.props

		if (!this.hasCheckedIfTodayExists && !isChecklist) {
			this.hasCheckedIfTodayExists = true

			// no matter what your time zone, it needs to check for your 'today'.
			let todoDays = this.todoDays
			let todayString = moment().format('Y-MM-DD')

			let todayIfExists = todoDays.find((todoDayId) => {
				let day = allTodoDays[todoDayId]

				return day.date === todayString
			})

			if (!todayIfExists) {
				createTodoDay(todayString)
			}

			// This can trigger pretty much immediately twice, resulting in 2 todoDays...
			setTimeout(_ => {
				this.hasCheckedIfTodayExists
			}, 100)
		}
	}

	updateInputValue = e => {
		this.setState({
			inputValue: e.target.value
		})
	}

	handleSubmit = _ => {
		const {
			isChecklist,
			createTodo,
			createChecklistItem,
			task,
		} = this.props

		const { 
			inputValue 
		} = this.state

		this.setState({
			inputValue: ''
		})

		if(isChecklist){
			createChecklistItem(inputValue, task)
		}else{
			createTodo(inputValue, 0, _ => {})
		}
	}

	changeDay = (direction, isActive) => {
		let currentDayIndex = this.props.currentTododayIndex

		if (isActive) {
			switch (direction) {
				case 'prev':
					currentDayIndex++
					break
				case 'next':
					currentDayIndex--
					break
				case 'end':
					currentDayIndex = 0
					break
				default:
					break
			}

			if (currentDayIndex < 0) {
				//alert('current day index is negative for some reason');
				currentDayIndex = 0
			}

			this.props.changeTodoDay(currentDayIndex)
		}
	}

	getTodayTodos = _ => {
		const {
			allTodos,
			allTodoDays
		} = this.props

		let todos = allTodoDays[this.todoDays[(this.todoDays.length - 1)]].todos

		todos.sort((a, b) => {
			return allTodos[a].order - allTodos[b].order
		})

		return todos
	}

	onDragStart = _ => {
		this.setState({
			isDragging: true
		})
	}

	onDragEnd = result => {
		const {
			isChecklist,
			allTodos,
			allChecklistItems,
			updateTodoOrder,
			updateChecklistItemOrder
		} = this.props

		if(!result.destination){
			return
		}

		this.setState({
			isDragging: false
		})

		const draggableId = result.draggableId.replace('todo-','')
		const newIndex = result.destination.index

		if (result.destination) {
			if(isChecklist){
				const items = copy(this.getItems())
				const object = allChecklistItems[draggableId]

				const itemIndex = items.findIndex(item => {
					return item.id === object.id
				})

				items.splice(itemIndex, 1)
				items.splice(newIndex, 0, object)

				updateChecklistItemOrder(items)
			}else{
				let updatedTodos = []

				const todosGroup = copy(this.getTodayTodos())
				const todoObject = allTodos[draggableId]

				todosGroup.splice(todosGroup.indexOf(todoObject.id), 1)
				todosGroup.splice(newIndex, 0, todoObject.id)

				todosGroup.forEach((todoId, index) => {
					let todo = allTodos[todoId]
					todo.order = index

					updatedTodos.push(todo)
				})

				updateTodoOrder(updatedTodos)
			}
		}
	}

	toggleShowCompleted = _ => {
		this.setState({
			showCompleted: !this.state.showCompleted
		})
	}

	isChecked = todo => {
		const {
			allTasks, 
			allMilestones,
			allProjects
		} = this.props

		let isChecked = false

		if (todo.is_checked) {
			isChecked = true
		}

		// it's kinda okay if the column doesn't exist. The todo will be set to complete if you click it anyway.
		if (todo.task_id) {
			const task = allTasks[todo.task_id]
			let statusId = null

			if(task){
				const milestone = allMilestones[task.milestone_id]

				if(milestone){
					const project = allProjects[milestone.project_id]

					if(project){
						statusId = getPrimaryColumnValue('status', task, project)
					}
				}
			}

			if (statusId == 3) {
				isChecked = true
			}
		}

		return isChecked
	}

	getItems = _ => {
		const {
			allTodos,
			isChecklist,
			optimisticTodo,
			optimisticChecklistItems,
			currentTododayIndex,
			task,
			checklistItems
		} = this.props

		const {
			areInputsVisible
		} = this.state

		const isToday = !currentTododayIndex

		let items = []

		if(isChecklist && task){
			items = [...checklistItems]
		}else{
			this.currentTododay.todos.forEach(todoId => {
				const todo = allTodos[todoId]

				if(todo){
					items.push(todo)
				}
			})
		}

		let optimisticItem = null

		if(optimisticTodo){
			optimisticItem = optimisticTodo
		}else if(optimisticChecklistItems && optimisticChecklistItems[task.id]){
			optimisticItem = optimisticChecklistItems[task.id]
		}

		if(optimisticItem && (isToday || isChecklist) && areInputsVisible){
			items.push(optimisticItem)
		}

		return doSort(items, 'number', 'order')
	}

	render() {
		const {
			todoDays,
			allTodoDays,
			allProjects,
			allMilestones,
			allTasks,
			currentTododayIndex,
			validateResponse,
			updateTask,
			isChecklist,
			isDisabled,
			optimisticTodo
		} = this.props

		const {
			showCompleted,
			areInputsVisible,
			areInputsTransitionedIn,
			isDragging
		} = this.state

		this.todoDays = todoDays.sort((a, b) => {
			return a - b
		})

		let todoDaysInReverseOrder = copy(this.todoDays).reverse()

		let validDaysInReverseOrder = []

		// ignore empty days
		todoDaysInReverseOrder.forEach((todoDayId, index) => {
			let todoDayObject = allTodoDays[todoDayId];
			if (todoDayObject.todos.length || index === 0) {
				validDaysInReverseOrder.push(todoDayObject);
			}
		})

		this.currentTododay = validDaysInReverseOrder[currentTododayIndex]

		let hasPreviousDay = false

		// let's just check if it's the first one - otherwise you get weird timezone stuff going on.
		const isToday = !currentTododayIndex
		let dateString = ''

		if (this.currentTododay) {
			let dayMoment = moment(this.currentTododay.date)

			// this can be done simpler
			if ((currentTododayIndex + 1) < validDaysInReverseOrder.length) {
				hasPreviousDay = true
			}

			dateString = dayMoment.format('dddd, MMMM D')
		}

		let todosListClassName = 'list todos-list'

		if(areInputsTransitionedIn){
			todosListClassName += ' visible'
		}

		return (
			<div>
				{ !isChecklist ?
				<h3>
					To-do
					{
						(validDaysInReverseOrder.length) > 1 ?
							<div className="header-tab-controls">
								<button 
									className={hasPreviousDay ? 'active' : null} 
									onClick={_ => { this.changeDay('prev', hasPreviousDay) }}
								>
									<Icon name="angle-left" />
									<span>
										Back
								</span>
								</button>
								<button 
									className={!isToday ? 'active' : null} 
									onClick={_ => { this.changeDay('end', !isToday) }}
								>
									<Icon name="angle-right" />
								</button>
								<button 
									className={!isToday ? 'active' : null} 
									onClick={_ => { this.changeDay('next', !isToday) }}
								>
									<span>
										Forward
								</span>
									<Icon name="angle-right" />
								</button>
							</div>
							: null
					}
				</h3>
				: null }
				{this.currentTododay &&
					<div className="header-tab headertab-list-container" ref="listContainer">
						<div className="todos-container">
							{ !isChecklist ?
							<h4>
								{dateString}
								<label className={showCompleted ? 'active' : null}>
									<Checkbox 
										isChecked={showCompleted} 
										onChange={this.toggleShowCompleted} 
									/>
									Show completed
								</label>
							</h4>
							: null }
							{isToday && !isChecklist &&
								<div className="todo-form">
									<InputStandard 
										outlineOnFocus={true} 
										ref={"todoInputElement"} 
										callback={this.handleSubmit} 
										value={this.state.inputValue} 
										onChange={this.updateInputValue} 
										placeholder="Enter a task here (or add one from a project)." 
										showPlus={true} 
									/>
									<ValidateResponse 
										dismissCallback={this.props.handleDismiss} 
										response={validateResponse} 
									/>
								</div>
							}
							<DragDropContext onDragStart={this.onDragStart} onDragEnd={this.onDragEnd}>
								<Droppable droppableId={'todos'} type="TODOS">
									{ provided => (
										<ul 
											className={todosListClassName} 
											ref={provided.innerRef}
										>
											{ this.getItems().map((item, index) => {
												if (!areInputsVisible) {
													return null
												}

												let task = null

												if(item.task_id && allTasks){
													task = allTasks[item.task_id]

													if(!task || task.deleted_at){
														task = null
													}
												}

												let isVisible = true

												if (!showCompleted && !isChecklist) {
													if (this.isChecked(item)) {
														isVisible = false
													}
												}

												return (
													<Todo 
														index={index} 
														isVisible={isVisible} 
														isDragging={isDragging} 
														updateTask={updateTask} 
														allProjects={allProjects} 
														allMilestones={allMilestones} 
														task={task} 
														key={item.id} 
														todo={item} 
														isToday={isToday} 
														isChecklist={isChecklist}
														isDisabled={isDisabled}
													/>
												)
											})}
											{provided.placeholder}
										</ul>
									)}
								</Droppable>
							</DragDropContext>
							{ (isChecklist && !isDisabled) ?
								<div>
									<InputStandard 
										outlineOnFocus={true} 
										ref={"todoInputElement"} 
										callback={this.handleSubmit} 
										value={this.state.inputValue} 
										onChange={this.updateInputValue} 
										placeholder="What steps are required?"
										showPlus={true} 
									/> 
								</div>
							: null }
							{
								(isToday && !this.currentTododay.todos.length && !isChecklist && !optimisticTodo) ?
									<AlertBanner 
										title={"No to-dos"} 
										body="Add tasks from your projects here, then tick 'em off" 
									/>
									: null
							}
						</div>
					</div>
				}
			</div>
		)
	}
}

function mapStateToProps(state) {
	return {
		todoDays: state.account.entities.users[state.account.entities.users[state.auth.userId].id].todo_days,
		currentTododayIndex: state.auth.currentTododayIndex,
		allTodoDays: state.account.entities.todo_days,
		allTodos: getAccountTodos(state),
		allTasks: state.account.entities.tasks,
		allChecklistItems: state.account.entities.checklist_items,
		userData: state.account.entities.users[state.account.entities.users[state.auth.userId].id],
		allMilestones: state.account.entities.milestones,
		allProjects: state.account.entities.projects,
		optimisticTodo: state.account.optimisticTodo,
		optimisticChecklistItems: state.account.optimisticChecklistItems
	}
}

const TodosWithValidateResponse = withValidateResponse(Todos)

export default connect(mapStateToProps, {
	createTodoDay,
	changeTodoDay,
	createTodo,
	updateTodo,
	updateTask,
	updateTodoOrder,
	createChecklistItem,
	updateChecklistItemOrder,
	refreshUserData
})(TodosWithValidateResponse)

let allFacts = ["Banging your head against a wall burns 150 calories an hour.",
	"In Switzerland it is illegal to own just one guinea pig.",
	"Pteronophobia is the irrational fear of being tickled by feathers.",
	"Snakes can help predict earthquakes.",
	"A flock of crows is known as a murder.",
	"The average woman uses her height in lipstick every 5 years.",
	"If you lift a kangaroo’s tail off the ground it can’t hop.",
	"Bananas are curved because they grow towards the sun.",
	"King Henry VII slept with a gigantic axe beside him.",
	"A baby octopus is about the size of a flea when it’s born.",
	"A lion’s roar can be heard from 5 miles away.",
	"95% of people text things they could never say in person.",
	"French language has 17 words for ‘surrender’",
	"Bob Dylan’s real name is Robert Zimmerman.",
	"There is a total of 1,665 steps in the Eiffel Tower.",
	"The Pokemon Hitmonlee is based off Bruce Lee.",
	"Octopuses have four pairs of arms.",
	"It snowed in the Sahara desert in 1979.",
	"Every human spent about half an hour as a single cell.",
	"If you leave everything to the last minute … it will only take a minute.",
	"Birds don’t urinate.",
	"Slugs have 4 noses.",
	"The Bible is the most shoplifted book in the world.",
	"California has issued 6 driving licenses to ‘Jesus Christ’.",
	"Squirrels forget where they hide about 1/2 their nuts.",
	"George W. Bush was once a cheerleader.",
	"Paraskavedekatriaphobia is the fear of Friday the 13th.",
	"During your lifetime you spend 38-days brushing your teeth.",
	"In ‘The Lego Movie’ 3,863,484 unique bricks were used.",
	"A single ant can live up to 29 years.",
	"The world’s oldest piece of chewing gum is over 9,000 years old!",
	"A coyote can hear a mouse moving underneath a foot of snow.",
	"Bolts of lightning can shoot out of an erupting volcano.",
	"New York drifts about one inch farther away from London each year.",
	"A U.S. dollar bill can be folded approximately 4,000 times in the same place before it will tear.",
	"A sneeze travels about 100 miles per hour.",
	"Earth has traveled more than 5,000 miles in the past 5 minutes.",
	"It would take a sloth one month to travel one mile.",
	"10% of the World’s population is left handed.",
	"A broken clock is right two times every day.",
	"Bob Marley’s last words to his son before he died were 'Money can’t buy life.'",
	"A mole can dig a tunnel that is 300 feet long in only one night.",
	"A hippo’s wide open mouth is big enough to fit a 4-foot-tall child in.",
	"Chewing gum while you cut an onion will help keep you from crying.",
	"If you were to stretch a Slinky out until it’s flat, it would measure 87 feet long.",
	"Al Capone’s business card said he was a used furniture dealer",
	"There are more collect calls on Father’s Day than on any other day of the year.",
	"A crocodile can’t poke its tongue out.",
	"It is physically impossible for pigs to look up into the sky.",
	"Drying fruit depletes it of 30-80% of its vitamin and antioxidant content",
	"Blueberries will not ripen until they are picked.",
	"Ketchup was used as a medicine back in the 1930’s.",
	"Honey never spoils.",
	"About half of all Americans are on a diet on any given day.",
	"A hardboiled egg will spin, but a soft-boiled egg will not.",
	"Avocados are poisonous to birds.",
	"Chewing gum burns about 11 calories per hour.",
	"The number of animals killed for meat every hour in the U.S. is 500,000.",
	"If you try to suppress a sneeze, you can rupture a blood vessel in your head or neck and die.",
	"Celery has negative calories.",
	"Gorillas burp when they are happy.",
	"In New York, it is illegal to sell a haunted house without telling the buyer.",
	"In 2006 someone tried to sell New Zealand on eBay.",
	"A man from Britain changed his name to Tim Pppppppppprice.",
	"Apple launched a clothing line in 1986.",
	"A Swedish woman lost her wedding ring, and found it 16 years later- growing on a carrot in her garden.",
	"Cherophobia is the fear of fun.",
	"Pirates wore earrings because they believed it improved their eyesight.",
	"Human thigh bones are stronger than concrete.",
	"Scientists have tracked butterflies that travel over 3,000 miles.",
	"You breathe on average about 8,409,600 times a year.",
	"More than 60,000 people are flying over the United States in an airplane right now.",
	"Hamsters run up to 8 miles at night on a wheel.",
	"A waterfall in Hawaii goes up sometimes instead of down.",
	"Our eyes are always the same size from birth.",
	"During your lifetime, you will produce enough saliva to fill two swimming pools.",
	"You are 1% shorter in the evening than in the morning.",
	"The elephant is the only mammal that can’t jump!",
	"Most dust particles in your house are made from dead skin!",
	"If 33 million people held hands, they could make it all the way around the equator.",
	"Earth is the only planet that is not named after a god.",
	"'You are born with 300 bones, but by the time you are an adult you only have 206.",
	"A ten-gallon hat will only hold ¾ of a gallon.",
	"Just like fingerprints, everyone has different tongue prints.",
	"ATM’s were originally thought to be failures, because the only users were prostitutes and gamblers.",
	"Of all the words in the English language, the word 'set' has the most definitions.",
	"A 'jiffy' is the scientific name for 1/100th of a second.",
	"One fourth of the bones in your body are located in your feet.",
	"A traffic jam lasted for more than 10 days, with cars only moving 0.6 miles a day.",
	"The tongue is the strongest muscle in the body.",
	"More than 50% of the people in the world have never made or received a telephone call.",
	"The cigarette lighter was invented before the match.",
	"Sea otters hold hands when they sleep so that they do not drift apart.",
	"The male ostrich can roar just like a lion.",
	"Mountain lions can whistle.",
	"The giraffe’s tongue is so long that they can lick the inside of their own ear.",
	"Cows kill more people than sharks do.",
	"Cats have 32 muscles in each of their ears.",
	"Butterflies taste their food with their feet.",
	"A tarantula can live without food for more than two years.",
	"A hummingbird weighs less than a penny.",
	"An ostrich’s eye is bigger than its brain.",
	"Dogs are capable of understanding up to 250 words.",
	"A sheep, a duck and a rooster were the first passengers in a hot air balloon.",
	"A flea can jump up to 200 times its own height.",
	"A ball of glass will bounce higher than a ball of rubber.",
	"Saturn’s density is low enough that the planet would float in water.",
	"68% of the universe is dark energy, and 27% is dark matter.",
	"In the past 20 years, scientists have found over 1,000 planets outside of our solar system.",
	"There are 60,000 miles of blood vessels in the human body.",
	"If you started with $0.01 and doubled your money every day, it would take 27 days to become a millionaire.",
	"Only one person in two billion will live to be 116 or older.",
	"A person can live without food for about a month, but only about a week without water.",
	"You can’t kill yourself by holding your breath.",
	"Human birth control pills work on gorillas.",
	"There are no clocks in Las Vegas gambling casinos.",
	"Beetles taste like apples, wasps like pine nuts, and worms like fried bacon.",
	"What is called a 'French kiss' in the English-speaking world is known as an 'English kiss' in France.",
	"Months that begin on a Sunday will always have a 'Friday the 13th.'",
	"The placement of a donkey’s eyes in its’ heads enables it to see all four feet at all times!",
	"Some worms will eat themselves if they can’t find any food.",
	"Dolphins sleep with one eye open.",
	"It is impossible to sneeze with your eyes open.",
	"Russia has a larger surface area than Pluto.",
	"You can’t hum while holding your nose closed.",
	"Women have twice as many pain receptors on their body than men. But a much higher pain tolerance.",
	"There are more stars in space than there are grains of sand on every beach in the world.",
	"For every human on Earth there are 1.6 million ants.",
	"On Jupiter and Saturn it rains diamonds.",
	"Life is about making an impact, not making an income. --Kevin Kruse",
	"Whatever the mind of man can conceive and believe, it can achieve. –Napoleon Hill",
	"Strive not to be a success, but rather to be of value. –Albert Einstein",
	"I attribute my success to this: I never gave or took any excuse. –Florence Nightingale",
	"You miss 100% of the shots you don’t take. –Wayne Gretzky",
	"The most difficult thing is the decision to act, the rest is merely tenacity. –Amelia Earhart",
	"Every strike brings me closer to the next home run. –Babe Ruth",
	"Definiteness of purpose is the starting point of all achievement. –W. Clement Stone",
	"Life isn't about getting and having, it's about giving and being. –Kevin Kruse",
	"Life is what happens to you while you’re busy making other plans. –John Lennon",
	"We become what we think about. –Earl Nightingale",
	"Life is 10% what happens to me and 90% of how I react to it. –Charles Swindoll",
	"The mind is everything. What you think you become. –Buddha",
	"The best time to plant a tree was 20 years ago. The second best time is now. –Chinese Proverb",
	"Eighty percent of success is showing up. –Woody Allen",
	"Your time is limited, so don’t waste it living someone else’s life. –Steve Jobs",
	"Winning isn’t everything, but wanting to win is. –Vince Lombardi",
	"I am not a product of my circumstances. I am a product of my decisions. –Stephen Covey",
	"Either you run the day, or the day runs you. –Jim Rohn",
	"The best revenge is massive success. –Frank Sinatra",
	"Life shrinks or expands in proportion to one's courage. –Anais Nin",
	"What did the Zen Buddist say to the hotdog vendor? Make me one with everything.",
	"Horse walks into a bar. Bartender says, 'Why the long face?'",
	"I never make mistakes…I thought I did once; but I was wrong.",
	"What did the little fish say when he swam into a wall? DAM!",
	"Where does a sheep go for a haircut? To the baaaaa baaaaa shop!",
	"What does a nosey pepper do? Gets jalapeno business!",
	"What do you call a deer with no eyes? No eye deer.",
	"The past, present and future walk into a bar. It was tense.",
	"What goes 'ha ha thump'? A man laughing his head off.",
	"What did the grape say when he was pinched? Nothing, he gave a little wine.",
	"What’s brown and sticky? A stick!",
	"Why are pirates so mean? I don’t know, they just arrrrrrrrr!",
	"What do you get when you throw a piano down a mine shaft? A flat miner.",
	"What do you call cheese that’s not yours? It’s nacho cheese.",
	"What do you get when you put a candle in a suit of armor? A knight light.",
	"Have you heard about corduroy pillows?! They’re making headlines!",
	"Two drums and a cymbal fall off a cliff. Ba-dum Tish!",
	"There were two peanuts walking down a dark alley, one was assaulted.",
	"How do you make holy water? You boil the hell out of it.",
	"What did the 0 say to the 8? Nice belt!",
	"Why did the orange stop? Because, it ran outta juice.",
	"What’s brown and sounds like a bell? Dung!",
	"Why did the storm trooper buy an iphone? He couldn’t find the Droid he was looking for.",
	"Knock knock…who’s there? I eat mop. I eat mop who? Ooooo gross! (now do you get the earlier one?)",
	"Why is six afraid of seven? Because seven ate nine.",
	"Why did the stop light turn red??? You would too if you had to change in the middle if the street!",
	"Bacon and eggs walk into a bar and order a beer, the bartender says sorry, we don’t serve breakfast.",
	"What do you get when you cross an elephant and a rhino? Elephino!",
	"What did the farmer say when he couldn’t find his tractor? 'Where’s my Tractor?!'",
	"Have you heard about the duck that was arrested for dealing? He was selling 'quack'.",
	"How do you catch a tame rabbit? The ‘tame’ way.",
	"What did the green grape say to the purple grape? BREATHE!",
	"You can waste your lives drawing lines. Or you can live your life crossing them. --Shonda Rhimes",
	"Always do your best. What you plant now, you will harvest later.--Og Mandino",
	"Action is the foundational key to all success. --Pablo Picasso",
	"It is impossible to lick your elbow.",
	"A shrimp's heart is in it's head.",
	"It is physically impossible for pigs to look up into the sky.",
	"A pregnant goldfish is called a twit. ",
	"Rats and horses can't vomit.",
	"If you sneeze too hard, you can fracture a rib.",
	"If you keep your eyes open by force when you sneeze, you might pop an eyeball out.",
	"Rats multiply so quickly that in 18 months, two rats could have over a million descendants.",
	"Wearing headphones for just an hour will increase the bacteria in your ear by 700 times.",
	"In every episode of Seinfeld there is a Superman somewhere.",
	"A duck's quack doesn't echo, and no one knows why.",
	"23% of all photocopier faults worldwide are caused by people sitting on them and photocopying their butts.",
	"In the course of an average lifetime you will, while sleeping, eat 70 assorted insects and 10 spiders.",
	"Most lipstick contains fish scales.",
	"Like fingerprints, everyone's tongue print is different.",
	"Over 75% of people who read this will try to lick their elbow.",
	"Hot water is heavier than cold.",
	"If you went out into space, you would explode before you suffocated because there's no air pressure.",
	"The radioactive substance, Americanium - 241 is used in many smoke detectors.",
	"Sound travels 15 times faster through steel than through the air.",
	"On average, half of all false teeth have some form of radioactivity.",
	"A biological reserve has been made for golden toads because they are so rare.",
	"There are more than fifty different kinds of kangaroos.",
	"The female lion does ninety percent of the hunting.",
	"A group of twelve or more cows is called a flink.",
	"You can tell the sex of a horse by its teeth. Most males have 40, females have 36.",
	"The 57 on Heinz ketchup bottle represents the varieties of pickle the company once had.",
	"Your stomach produces a new layer of mucus every two weeks - otherwise it will digest itself.",
	"The Declaration of Independence was written on hemp paper.",
	"Susan Lucci is the daughter of Phyllis Diller.",
	"315 entries in Webster's 1996 Dictionary were misspelled.",
	"On average, 12 newborns will be given to the wrong parents daily.",
	"During the chariot scene in 'Ben Hur' a small red car can be seen in the distance.",
	"Donald Duck comics were banned from Finland because he doesn't wear any pants.",
	"Ketchup was sold in the 1830s as medicine.",
	"Leonardo da Vinci could write with one hand and draw with the other at the same time.",
	"Because metal was scarce, the Oscars given out during World War II were made of wood.",
	"There are no clocks in Las Vegas gambling casinos.",
	"The name Wendy was made up for the book Peter Pan, there was never a recorded Wendy before!",
	"There are no words in the dictionary that rhyme with: orange, purple, and silver!",
	"Leonardo Da Vinci invented scissors.",
	"A tiny amount of liquor on a scorpion will make it instantly go mad and sting itself to death.",
	"The mask used by Michael Myers in the original 'Halloween' was a Captain Kirk mask painted white.",
	"Chewing gum while peeling onions will keep you from crying!",
	"The glue on Israeli postage stamps is certified kosher.",
	"Guinness Book of Records holds the record for being the book most often stolen from Public Libraries.",
	"Beetles taste like apples, wasps like pine nuts, and worms like fried bacon.",
	"Of all the words in the English language, the word ’set’ has the most definitions!",
	"'Almost' is the longest word in the English language with all the letters in alphabetical order.",
	"'Rhythm' is the longest English word without a vowel.",
	"In 1386, a pig in France was executed by public hanging for the murder of a child",
	"Human thigh bones are stronger than concrete.",
	"You can’t kill yourself by holding your breath",
	"There is a city called Rome on every continent except Antarctica.",
	"It’s against the law to have a pet dog in Iceland.",
	"Your heart beats over 100,000 times a day.",
	"The skeleton of Jeremy Bentham is present at all important meetings of the University of London",
	"Your ribs move about 5 million times a year, everytime you breathe!",
	"The elephant is the only mammal that can’t jump!",
	"One quarter of the bones in your body, are in your feet!",
	"Fingernails grow nearly 4 times faster than toenails!",
	"Most dust particles in your house are made from dead skin!",
	"The present population of 5 billion plus people of the world is predicted to become 15 billion by 2080.",
	"Women blink nearly twice as much as men.",
	"Months that begin on a Sunday will always have a 'Friday the 13th.'",
	"Coca-Cola would be green if colouring weren’t added to it.",
	"On average a hedgehog’s heart beats 300 times a minute.",
	"The average lead fe-edit-2 will draw a line 35 miles long or write approximately 50,000 English words.",
	"More people are allergic to cow’s milk than any other food.",
	"Camels have three eyelids to protect themselves from blowing sand.",
	"The placement of a donkey’s eyes in its’ heads enables it to see all four feet at all times!",
	"The six official languages of the United Nations are: English, French, Arabic, Chinese, Russian and Spanish.",
	"Earth is the only planet not named after a god.",
	"It’s against the law to burp, or sneeze in a church in Nebraska, USA.",
	"You’re born with 300 bones, but by the time you become an adult, you only have 206.",
	"Some worms will eat themselves if they can’t find any food!",
	"Dolphins sleep with one eye open!",
	"It is impossible to sneeze with your eyes open",
	"The worlds oldest piece of chewing gum is 9000 years old!",
	"The longest recorded flight of a chicken is 13 seconds",
	"Slugs have 4 noses.",
	"Owls are the only birds who can see the colour blue.",
	"A man named Charles Osborne had the hiccups for 69 years!",
	"A giraffe can clean its ears with its 21-inch tongue!",
	"The average person laughs 10 times a day!",
	"An ostrich’s eye is bigger than its brain",
	"The human heart! creates enough pressure when it pumps out to the body to squirt blood 30 feet.",
	"A pig's orgasm lasts 30 minutes.",
	"A cockroach will live for weeks without its head before it starves to death",
	"Banging your head against a wall uses 150 calories a hour",
	"The flea can jump 350 times its body length. It's like a human jumping the length of a football field.",
	"The catfish has over 27,000 taste buds.",
	"Some lions mate over 50 times a day.",
	"Butterflies taste with their feet.",
	"The strongest muscle in the body is the tongue.",
	"A cat's urine glows under a black light.",
	"Starfish have no brains.",
	"Polar bears are left-handed.",
	"Humans and dolphins are the only species that have sex for pleasure.",
	"Most toilets flush in E flat.",
	"Cap’n Crunch’s full name is Horatio Magellan Crunch.",
	"Approximately 40,000 Americans are injured by toilets each year.",
	"Sean Connery wore a toupee in all his James Bond movies.",
	"Nicholas Cage bought a pet octopus once.",
	"You’ll eat more than 35,000 cookies in your lifetime (probably).",
	"Steve Jobs relieved stress by soaking his feet in Apple’s company toilets.",
	"All swans in England belong to the queen.",
	"No piece of square paper can be folded more than 7 times in half.",
	"The 'hashtag' key on your keyboard (#) is called an octotroph.",
	"The Declaration of Independence was written on hemp paper.",
	"Minnie Mouse full name is Minerva Mouse.",
	"There are more plastic flamingos in the U.S, than real ones!",
	"At any one time about 0.7% of the world’s population is drunk.",
	"315 entries in Webster’s Dictionary were misspelled.",
	"There is a hotel in Sweden built entirely out of ice; it is rebuilt every year.",
	"Because metal was scarce, the Oscars given out during World War II were made of wood.",
	"Ancient Egyptian priests would pluck every hair from their bodies.",
	"M&M’s actually stands for 'Mars & Murrie’s'.",
	"In 1907, an ad campaign for Kellogg’s Corn Flakes offered a free box of cereal to any woman who would wink at her grocer.",
	"Grapes explode when you put them in the microwave.",
	"A pound of houseflies contains more protein than a pound of beef.",
	"The international telephone area code for Antarctica is 672.",
	"The male seahorse carries the eggs until they hatch instead of the female.",
	"A giraffe can clean its ears with its 21-inch tongue.",
	"Albert Einstein and Charles Darwin both married their cousins.",
	"Cats sleep for 70% of their lives.",
	"More monopoly money is printed each year than real US currency.",
	"Too many of us are not living our dreams because we are living our fears. –Les Brown",
	"If you want to lift yourself up, lift up someone else. –Booker T. Washington",
	"I didn’t fail the test. I just found 100 ways to do it wrong. –Benjamin Franklin",
	"There are no traffic jams along the extra mile. –Roger Staubach",
	"The first item on the McDonalds menu was a hotdog.",
	"Jeff Bezos’ (the founder of Amazon) father was a circus performer.",
	"Until 1996 Marvel owned the rights to the word 'Zombie'.",
	"The average mobile user checks their mobile phone 150 times a day!",
	"Google was originally called BackRub.",
	"Cleopatra lived closer in time to the Moon landing than to the construction of the Great Pyramid of Giza.",
	"The state sport of Maryland is jousting.",
	"There are more possible iterations of a game of chess than there are atoms in the known universe.",
	"It can take a photon 40,000 years to travel from the core of the sun to the surface.",
	"Yahoo' is actually an acronym for 'Yet Another Hierarchical Officious Oracle.'",
	"German chocolate cake is named after a guy named Sam German, not the country.",
	"There's an island in Japan you can visit that's inhabited only by friendly bunnies.",
	"There are actually more public libraries in the US than McDonald's.",
	"The last letter added to the English alphabet wasn't Z — it was the letter J.",
	"Before the invention of color TV, 75% of people said they dreamed in black and white. Today, only 12%.",
	"The British royal family isn't allowed to play Monopoly.",
	"Paper bags aren't any better for the environment than plastic ones.",
	"The voice of Mickey Mouse and the voice of Minnie Mouse got married IRL.",
	"For a short time, the planet Uranus was named...George.",
	"Toilet seat covers are basically pointless.",
	"There is an island in the Bahamas that's inhabited only by swimming pigs.",
	"There are lower-case numbers in addition to lower-case letters.",
	"For a brief time, Melbourne had the best name on the planet: Batmania.",
	"Richard Nixon once smuggled a suitcase full of weed through the airport for Louis Armstrong.",
	"Lego is the largest tire manufacturer in the world.",
	"A 'buttload' is a real measurement of weight.",
	"If someone gives opinions on topics they know nothing about, they're an ultracrepidarian.",
	"There's a high school in Minnesota that gives service dogs yearbook photos.",
	"Mother's Day was quite literally invented to be anti-commercialism.",
	"The logo for Chupa Chups was designed by Salvador Dalí.",
	"Modern thong underwear was introduced by Fiorello LaGuardia, the mayor of New York City.",
	"A writer predicted how the Titanic would sink in 1898, 13 years before it was even built.",
	"In Queensland, Australia, it's illegal to own a pet rabbit unless you're a magician.",
	"Sea otters have a pouch under their forearm to store their favorite rocks.",
	"T-shirts were originally marketed to unmarried men who didn't know how to sew buttons back on.",
	"All colors of Froot Loops have the same flavor.",
	"Prior to the 20th century, squirrels were one of America's most popular pets.",
	"Cows have 'best friends' and get stressed when separated.",
	"Miami is the only major US city founded by a woman.",
	"Anxious travelers can play with mini horses at a Kentucky airport.",
	"Shaggy from Scooby Doo's real name is Norville Rogers.",
	"There are turtle tunnels in Japan to save them from being run over by trains.",
	"Baby puffins are called pufflings.",
	"Every year on Aug. 5, the Mars Curiosity rover sings itself a sad, solitary 'Happy Birthday.'",
	"April 18, 1930, was such a slow news day that at 6:30 PM, the BBC's radio announcer said, 'There is no news.'",
	"For a short time, the planet Uranus was named...George.",
	"A pound of houseflies contains more protein than a pound of beef.",
	"The longest recorded flight of a chicken is 13 seconds",
	"In every episode of Seinfeld there is a Superman somewhere."]


// WEBPACK FOOTER //
// ./src/layout/header/header-tabs/todos.jsx